import React from 'react';
import Head from 'next/head';
import { getFaviconFromPageProps, useNextDataHrefInterceptor } from '@raisin/cp-utils';
import { initializeAPM } from '@raisin/fe-apm';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/800.css';
import { type RaisinAppProps } from '@raisin/cp-layout';
import StyledTheme from 'utils/styledTheme';
import packageData from '../../package.json';

declare const zonePathGlobal: string;

initializeAPM({ zoneName: 'cp-user-account', version: packageData.version });

function App({ Component, pageProps, router }: RaisinAppProps) {
  useNextDataHrefInterceptor({ router });
  const favicon = getFaviconFromPageProps(pageProps, `${zonePathGlobal}/cp_assets/favicon.ico`);

  return (
    <StyledTheme>
      <Head>
        <link rel="icon" href={favicon} />
      </Head>
      <Component {...pageProps} />
    </StyledTheme>
  );
}

export default App;
